import { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { api } from "@/lib/api";

const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  const [state, setState] = useState(location.state?.user ? "authed" : null);
  const [user, setUser] = useState(location.state?.user || null);

  useEffect(() => {
    if (location.state?.user) return;
    if (window.location.hash?.includes("session_id=")) return;
    let alive = true;
    api("/auth/me")
      .then((u) => {
        if (alive) {
          setUser(u);
          setState("authed");
        }
      })
      .catch(() => alive && setState("guest"));
    return () => {
      alive = false;
    };
  }, [location.state]);

  if (state === null) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[#F7F7F5]">
        <div className="h-8 w-8 animate-spin rounded-full border-2 border-guinep-line border-t-guinep-deep" />
      </div>
    );
  }
  if (state === "guest") return <Navigate to="/login" replace />;
  return children(user);
};

export default ProtectedRoute;
